import React, { useState, createContext } from 'react'

export const GlobalAppointmentContext = createContext();

const GlobalAppointmentContextProvider = (props) => {
  const [getGlobalAppointment, setGlobalAppointment] = useState({hasConfirmation: false});

  return (
    <GlobalAppointmentContext.Provider value={{getGlobalAppointment, setGlobalAppointment}}>
      {props.children}
    </GlobalAppointmentContext.Provider>
  )
}

export default GlobalAppointmentContextProvider;
